import { TextField } from "@mui/material";
import { colorPrimary, colorRed, colorSecondary, lightenColor } from "@/constants/colors";
import { Hint } from "@/HOC";
import { TCustomTextFieldProps } from "./CustomTextField.props";

const CustomTextField = ({ hint = "", hintPosition, ...props }: TCustomTextFieldProps): JSX.Element => {
	return (
		<Hint hint={hint} position={hintPosition} width={props.fullWidth ? "100%" : undefined}>
			<TextField
				{...props}
				InputProps={{
					...props.InputProps,
					sx: {
						minHeight: 33,
						height: props.multiline ? "auto" : 33,
						color: props.error ? colorRed : colorPrimary,
						fontFamily: "inherit",
						fontSize: 13,
						fontStyle: "inherit",
						fontWeight: "inherit",
						lineHeight: "inherit",
						letterSpacing: "inherit",
						...props.InputProps?.style,
					},
				}}
				InputLabelProps={{
					...props.InputLabelProps,
					style: {
						color: colorPrimary,
						fontFamily: "inherit",
						fontSize: 13,
						fontStyle: "inherit",
						fontWeight: "inherit",
						lineHeight: "inherit",
						letterSpacing: "inherit",
						...props.InputLabelProps?.style,
					},
				}}
				sx={{
					// disabled
					"& .MuiInputBase-root.Mui-disabled": { color: lightenColor(colorPrimary, "40%") },
					"& .MuiInputBase-root.Mui-disabled .MuiOutlinedInput-notchedOutline": { borderColor: lightenColor(colorPrimary, "40%") },
					"& .MuiInputLabel-root.Mui-disabled": { color: lightenColor(colorPrimary, "40%") + " !important" }, // placeholder
					"& .MuiInputBase-input.Mui-disabled": { WebkitTextFillColor: lightenColor(colorPrimary, "40%") }, // native input (фикс для Chrome)

					'.MuiInputLabel-root[data-shrink="false"]': { top: -8 }, // placeholder
					'.MuiInputLabel-root[data-shrink="false"].Mui-error': { color: colorRed + "!important" }, // placeholder + error

					".MuiInputBase-input.MuiOutlinedInput-input": { paddingBlock: "7px" }, // native input
					".MuiInputBase-root.MuiInputBase-multiline": { paddingBlock: "7px" }, // для textarea
					".MuiInputBase-input.MuiOutlinedInput-input.MuiInputBase-inputMultiline": { paddingBlock: 0 }, // native textarea

					'.MuiInputLabel-root[data-shrink="true"].Mui-focused': { color: colorSecondary + "!important" }, // legend focused
					'.MuiInputLabel-root[data-shrink="true"].Mui-error': { color: colorRed + "!important" }, // legend + error

					".Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: colorSecondary + "!important" }, // border focused
					".Mui-focused.Mui-error .MuiOutlinedInput-notchedOutline": { borderColor: colorRed + "!important" }, // border focused + error
					textAlign: "left",
					...props.sx,
				}}
			/>
		</Hint>
	);
};

export default CustomTextField;
